import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ToastController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { CustomersService } from '../../services/customers/customers-service';
import { Customer } from '../../models/customer';

@IonicPage()
@Component({
  selector: 'page-customer-detail',
  templateUrl: 'customer-detail.html',
})
export class CustomerDetailPage {
  public Customer: Customer;
  private profileForm: FormGroup;

  // Alert error notification.
  getError(ctrl) {
    return ctrl && typeof ctrl === 'object' && ctrl.hasOwnProperty("errors") ? (ctrl.errors ? Object.keys(ctrl.errors).join(", ") : false) : false;
  }

  // Key-press event handler sanitizes
  // input values for credit card numbers.
  numOnlyMask(keyCode) {
    return [8,48,49,50,51,52,53,54,55,56,57,189].indexOf(parseInt(keyCode)) > -1;
  }

  toCamelCase(str): string {
    return str.split("_").map(function(word,index){

      // If it is the first word make sure to lowercase all the chars.
      if(index == 0) {
        return String(word).toLowerCase();
      }

      // If it is not the first word only upper case the first char and lowercase the rest.
      return String(word).charAt(0).toUpperCase() + String(word).slice(1).toLowerCase();

    }).join("");
  }

  save(profileForm)
  {
    let self: CustomerDetailPage = this;
    let p: string;

    for(p in profileForm)
    {
      if(profileForm[p] === this.Customer.get(p))
      {
        delete profileForm[p];
      }
    }

    if(Object.keys(profileForm).length === 0)
    {
      let toast = this.toastCtrl.create({
        message: `There were no changes to ${self.Customer.name()}'s account to save.`,
        duration: 6000,
        position: "top"
      });
      toast.present();
      return;
    }

    let loading = this.loadingCtrl.create({
      content: "Saving..."
    });

    loading.present();

    this.custService.update(this.Customer.get("meta").subscription_id,{profile: profileForm})
      .subscribe(
        res => {
          loading.dismiss();

          // change to camelCase
          let o: object = {};
          for(var e in res){ o[self.toCamelCase(e)] = res[e]; }

          // store customer record.
          self.Customer = new Customer(o);
          self.custService.set(self.Customer);

          // toast!
          let toast = this.toastCtrl.create({
            message: `Success. ${self.Customer.name()}'s account was successfully updated.`,
            duration: 6000,
            position: "top"
          });

          toast.present();
        },
        rej => {
          loading.dismiss();

          let toast = this.toastCtrl.create({
            message: rej.error.message,
            duration: 8000,
            position: "top"
          });

          toast.present();
        }
      );
  }

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public custService: CustomersService,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private formBuilder: FormBuilder) {

      // set customer data model.
      this.Customer = this.custService.get();

      // define form group.
      this.profileForm = this.formBuilder.group({
          firstName: [this.Customer.get("firstName"), Validators.compose([Validators.minLength(2), Validators.maxLength(40), Validators.pattern(/^[a-zA-Z]*$/), Validators.required])],
          lastName: [this.Customer.get("lastName"), Validators.compose([Validators.minLength(2), Validators.pattern(/^[a-zA-Z\-]*$/), Validators.required])],
          email: [this.Customer.get("email")],
          phone: [this.Customer.get("phone"), Validators.compose([Validators.required])],
          dob: [this.Customer.get("dob")]
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/customer-detail/customer-detail.ts